import appConfigActions from './appActions';
import globalConfigActions from './globalConfigActions';
import formConfigActions from './formConfigActions';
import termsConfigActions from './termsConfigActions';
import formElementsActions from './formElementsActions';
import formSessionActions from './formSessionActions';
import userActions from './userActions';

const allActions = {
  appConfigActions,
  globalConfigActions,
  formConfigActions,
  termsConfigActions,
  formElementsActions,
  formSessionActions,
  userActions,
};

export default allActions;
